import { useUserStore } from '@hooks/useUserStore';
import { useQueryClient } from '@tanstack/react-query';
import { LocalStorage } from '@utils/LocalStorage';
import { useCancerDetectUser } from '@hooks/useCancerDetectUser';
import { Sentry } from '@/main.tsx';

const cleanupForethoughtWidget = () => {
  // Remove the script element
  const scriptElement = document.getElementById('forethought-widget-embed-script');
  if (scriptElement) {
    scriptElement.remove();
  }

  // Remove Forethought widget containers (they use dynamic IDs starting with 'forethought-')
  const widgetContainers = document.querySelectorAll('[id^="forethought-"]');
  widgetContainers.forEach((element) => element.remove());

  // Remove any elements with Forethought-specific classes
  const forethoughtElements = document.querySelectorAll('[class*="forethought"]');
  forethoughtElements.forEach((element) => element.remove());

  // Remove iframe if created by the widget
  const forethoughtIframes = document.querySelectorAll('iframe[src*="forethought"]');
  forethoughtIframes.forEach((iframe) => iframe.remove());
};

const useLogout = () => {
  const { setUser } = useUserStore();
  const { setIsCancerDetectClicked } = useCancerDetectUser();
  const queryClient = useQueryClient();

  return () => {
    queryClient.clear();
    setUser(undefined);
    setIsCancerDetectClicked(false);
    Sentry.setUser(null);
    LocalStorage.clear();
    LocalStorage.removeItem('user');
    LocalStorage.removeItem('bootup');
    LocalStorage.removeItem('auth_token');
    sessionStorage.clear();
    
    // Cleanup Forethought widget on logout
    cleanupForethoughtWidget();
  };
};

export default useLogout;
